import React, {Fragment, Component} from "react";
import { connect } from "react-redux";
import LoadingDots from '../components/ui/LoadingDots';

import MasterTable from './mentorTable/MasterTable';
import SpecialistTable from "./mentorTable/SpecialistTable";

import { setMentor, setAllowDefence } from '../actions/mentor';
import { Tabs } from '../const/mentors';

class Mentor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
      navOpen: true,
    }
  }

  componentDidMount() {
    const { user } = this.props;
    if (user.is_mentor) this.setState({'activeTab': 0});
    if (user.is_specialist) this.setState({'activeTab': 5});
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    const { user } = this.props;
    if (user.is_mentor && !prevProps.user.is_mentor) this.setState({'activeTab': 0});
    if (user.is_specialist && !prevProps.user.is_specialist) this.setState({'activeTab': 5});
  }

  countRequestByTab = tab => {
    const { process: { all } } = this.props;
    const requests = all.filter(item => typeof item !== 'undefined');

    if (!tab || !tab.count || !tab.filter) return '';

    const count = tab.filter(requests).length;

    return count || 0;
  };

  filterBy = (array, byField) => {
    if (!Array.isArray(array)) {
      []
    }
    return array.filter(item => item.request_type === byField && !item.is_completed)
  }

  renderTab = () => {
    const { activeTab } = this.state;
    const { process: { all }, setMentor, user, setAllowDefence } = this.props;

    const activeTabContent = Tabs.find(tab => tab.id === activeTab);
    const filter = Tabs.find(tab => tab.id === activeTab).filter;

    const toShow = typeof filter !== 'undefined' ? filter(all) : all.filter(item => typeof item !== 'undefined');
    //TODO: Rebuild - Оптимизировать в дальнейшем !!!
    // Возможно в табах хранить не цифру  0: {filterBy: 'appointed' | 'unappointed'} - обсудить
    switch (activeTab) {
      //=============
      //is_mentor
      case 0: {
        return (
            <MasterTable
              tabInfo={activeTabContent}
              rows={this.filterBy(toShow, 'public')}
              setMentor={setMentor}
            />
        );
      }
      case 1: {
        return (
          <MasterTable
            tabInfo={activeTabContent}
            rows={this.filterBy(toShow, 'appointed')}
            setMentor={setMentor}
          />
        );
      }
      case 2: {
        return (
          <MasterTable
            tabInfo={activeTabContent}
            rows={this.filterBy(toShow, 'accepted')}
            setMentor={setMentor}
          />
        );
      }
      case 3: {
        return (
          <MasterTable
            tabInfo={activeTabContent}
            rows={this.filterBy(toShow, 'others')}
            setMentor={setMentor}
          />
        );
      }
      case 4: {
        return (
          <MasterTable
            tabInfo={activeTabContent}
            rows={toShow.filter(item => item.is_completed)}
            setMentor={setMentor}
          />
        );
      }
      //=============
      //is_specialist
      case 5: {
        return (
          <SpecialistTable
            tabInfo={activeTabContent}
            rows={this.filterBy(toShow, 'appointed')}
            setMentor={setMentor}
          />
        );
      }
      case 6: {
        return (
          <SpecialistTable
            tabInfo={activeTabContent}
            rows={this.filterBy(toShow, 'in_progress')}
            setMentor={setMentor}
          />
        );
      }
      case 7: {
        return (
          <SpecialistTable
            tabInfo={activeTabContent}
            rows={toShow.filter(item => item.is_completed)}
            setMentor={setMentor}
          />
        );
      }
      default: {
        return (
          <div className="reportbox-content">
            <h4>{activeTabContent.title}</h4>
            <div className="line" />
          </div>
        );
      }
    }
  };

  toggleTab = (tab) => () => {
    this.setState({
      activeTab: tab.id,
    });
  }

  render() {
    const { user, loaders } = this.props;
    const { activeTab , navOpen } = this.state;
    const role = user.is_mentor ? 'mentor' : (user.is_specialist ? 'specialist' : null);

    const activeTabContent = Tabs.find(tab => tab.id === activeTab);

    return (
      <div id="content" className="nopad">
        <LoadingDots show={['flows', 'mm-process','slave-mentors','mentor-process'].some(el => loaders[el])}>
          <div className="reportbox">
            <div className="reportbox-content-row">
              <div className="reportbox-sidebar">
                <div className="reportbox-sidebar-heading">
                  <span className="reportbox-sidebar-heading-title">Заявки от пользователей</span>
                </div>
                <div className="reportbox-sidebar-menu">
                  <ul className={`nav nav-pills nav-stacked ${navOpen ? 'nav--opened' : ''}`}>
                    {Tabs.filter(tab => tab.roles.indexOf(role) > -1).map(tab => (
                      <Fragment key={tab.id}>
                        {((tab.id === 4 && (user?.is_mentor)) || (tab.id === 7 && (user?.is_specialist))) && (
                          <li>
                            <a href={`/planner/`} className="btn btn-primary btn-for-planner">
                              Перейти в планировщик
                            </a>
                          </li>
                        )}
                        <li className={this.state.activeTab === tab.id ? 'active' : ''}>
                          <a onClick={this.toggleTab(tab)}>
                            <span className="nav-pills-label">{tab.title}</span>
                            {!!tab.count &&(
                              <span className={`label label-${tab.count} label--circle`}>
                                {this.countRequestByTab(tab)}
                              </span>
                            )}
                          </a>
                        </li>
                      </Fragment>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="reportbox-content-viewport">
                {!!role
                    && activeTabContent
                    && activeTabContent.roles.indexOf(role) > -1
                    && this.renderTab(this.state.activeTab)}
              </div>
            </div>
          </div>
        </LoadingDots>
      </div>
    )
  }
}

function mapStateToProps(state) {

  const getProcess = () => {
    return state.forms.process.all.length ? {
      all: state.forms.process.all.map((item) => {
        return {
          ...item
        }
      })
    } : state.forms.process
  }

  return {
    loaders: state.forms.loaders,
    process: getProcess(),
    mentors: state.forms.mentors,
    user: state.forms.user,
  };
}

const mapDispatchToProps = {
  setMentor,
  setAllowDefence,
};

export default connect(mapStateToProps, mapDispatchToProps)(Mentor);
